import { func, bool } from 'prop-types';
import { useParams, useLocation } from 'react-router-dom';
import { ActionModal } from 'components';
import { useTranslation } from 'react-i18next';
import UIHelper from 'helpers/UIHelper';
import { useNavigate } from 'hooks/useNavigate';

const DeleteModal = ({ onClickDelete, loading, description = '' }) => {
  const { t } = useTranslation();
  const history = useNavigate();
  let { id } = useParams();
  const { pathname } = useLocation();

  const handleOk = () => {
    onClickDelete(id);
  };
  const handleCancel = () => {
    history(UIHelper.getListRoute(pathname));
  };

  return (
    <ActionModal
      loading={loading}
      title={t('Sei sicuro di voler cancellare?')}
      description={description}
      yesBtnText={t('Si, cancella')}
      noBtnText={t('No, lascia')}
      onClickOk={handleOk}
      onCancel={handleCancel}
      value={id}
    />
  );
};

DeleteModal.propTypes = {
  onClickDelete: func,
  loading: bool,
};

export default DeleteModal;
